/**
 * @desc 海关要素-分页查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.CustomsInfoResponseDto>
>;
export function request(
  params: API.basics.customsInfo.pageList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/customsInfo/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
